import React from 'react';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig } from '../config/filterConfig';

const AcompanhamentosFilter = ({
  onApply,
  loading
}) => {
  return <FilterPanel filters={filterConfig} onApply={onApply} loading={loading} title="Filtros de Acompanhamentos" />;
};

export default AcompanhamentosFilter;
